export interface ConfigTypes {
  metaTitle: string;
  metaDescription: string;
  canonicalUrl: string;
  footerLinks: {
    foxLinks: {
      title: string;
      href: string;
    }[];
    foxNetworks: {
      title: string;
      href: string;
    }[];
  };
}

const config: ConfigTypes = {
  metaTitle: 'Stream Live News, Sports, and Entertainment | FOX One',
  metaDescription:
    'Everything FOX in one place. A single destination to stream live sports, news and on-demand entertainment – made for how you watch.',
  canonicalUrl: 'https://www.fox.com',
  footerLinks: {
    foxLinks: [
      {
        title: 'About Ads',
        href: '/privacy-policy/#ad-choices',
      },
      {
        title: 'Privacy Policy',
        href: '/privacy-policy',
      },
      {
        title: 'Your Privacy Choices',
        href: 'https://privacy.fox.com/main/web/main',
      },
      {
        title: 'Terms of Use',
        href: '/terms-of-use',
      },
      {
        title: 'TV Parental Guidelines',
        href: 'http://www.tvguidelines.org/',
      },
      {
        title: 'Accessibility',
        href: '/accessibility',
      },
      {
        title: 'Help',
        href: 'https://help.fox.com/',
      },
      {
        title: 'Viewer Feedback',
        href: 'https://foxapps.my.salesforce-sites.com/feedback',
      },
    ],
    foxNetworks: [
      {
        title: 'Fox News',
        href: 'https://www.foxnews.com/',
      },
      {
        title: 'Fox Nation',
        href: 'https://nation.foxnews.com/',
      },
      {
        title: 'Fox Weather',
        href: 'https://www.foxweather.com/',
      },
      {
        title: 'Fox Local',
        href: 'https://www.foxlocal.com/',
      },
      {
        title: 'Fox Business',
        href: 'https://www.foxbusiness.com/',
      },
      {
        title: 'Fox Sports',
        href: 'https://www.foxsports.com/',
      },
      {
        title: 'Tubi',
        href: 'https://tubitv.com/',
      },
    ],
  },
};

export default config;
